import commonUtil from '../../../../utils/commonUtil';

export const GET_RECEIVED_GIFT_LIST = 'GET_RECEIVED_GIFT_LIST';
export const GET_RECEIVED_GIFT_LIST_SUCCESS = 'GET_RECEIVED_GIFT_LIST_SUCCESS';
export const GET_RECEIVED_GIFT_LIST_FAIL = 'GET_RECEIVED_GIFT_LIST_FAIL';

export const GET_REGISTERED_GIFT_LIST = 'GET_REGISTERED_GIFT_LIST_LOAD';
export const GET_REGISTERED_GIFT_LIST_SUCCESS =
  'GET_REGISTERED_GIFT_LIST_SUCCESS';
export const GET_REGISTERED_GIFT_LIST_FAIL = 'GET_REGISTERED_GIFT_LIST_FAIL';

export const GET_ALL_REGISTERED_GIFT_LIST = 'GET_ALL_REGISTERED_GIFT_LIST_LOAD';
export const GET_ALL_REGISTERED_GIFT_LIST_SUCCESS =
  'GET_ALL_REGISTERED_GIFT_LIST_SUCCESS';
export const GET_ALL_REGISTERED_GIFT_LIST_FAIL = 'GET_ALL_REGISTERED_GIFT_LIST_FAIL';

export const GET_PERSONAL_SHOPPING_LIST = 'GET_PERSONAL_SHOPPING_LIST';
export const GET_PERSONAL_SHOPPING_LIST_SUCCESS =
  'GET_PERSONAL_SHOPPING_LIST_SUCCESS';
export const GET_PERSONAL_SHOPPING_LIST_FAIL =
  'GET_PERSONAL_SHOPPING_LIST_FAIL';

export const GET_EVENT_SUMMARY_INFO = 'GET_EVENT_SUMMARY_INFO';
export const GET_EVENT_SUMMARY_INFO_SUCCESS = 'GET_EVENT_SUMMARY_INFO_SUCCESS';
export const GET_EVENT_SUMMARY_INFO_FAIL = 'GET_EVENT_SUMMARY_INFO_FAIL';

export const SET_FAVOURITE_GIFT = 'SET_FAVOURITE_GIFT';
export const SET_FAVOURITE_GIFT_SUCCESS = 'SET_FAVOURITE_GIFT_SUCCESS';
export const SET_FAVOURITE_GIFT_FAIL = 'SET_FAVOURITE_GIFT_FAIL';

export const SET_QUANTITY = 'SET_QUANTITY';
export const SET_QUANTITY_SUCCESS = 'SET_QUANTITY_SUCCESS';
export const SET_QUANTITY_FAIL = 'SET_QUANTITY_FAIL';

export const SET_DELIVERY_ADDRESS = 'SET_DELIVERY_ADDRESS';
export const SET_DELIVERY_ADDRESS_SUCCESS = 'SET_DELIVERY_ADDRESS_SUCCESS';
export const SET_DELIVERY_ADDRESS_FAIL = 'SET_DELIVERY_ADDRESS_FAIL';

export const SET_MODE_OF_DELIVERY = 'SET_MODE_OF_DELIVERY';
export const SET_MODE_OF_DELIVERY_SUCCESS = 'SET_MODE_OF_DELIVERY_SUCCESS';
export const SET_MODE_OF_DELIVERY_FAIL = 'SET_MODE_OF_DELIVERY_FAIL';

export const REMOVE_GIFT = 'REMOVE_GIFT';
export const REMOVE_GIFT_SUCCESS = 'REMOVE_GIFT_SUCCESS';
export const REMOVE_GIFT_FAIL = 'REMOVE_GIFT_FAIL';

export const GET_MESSAGES = 'GET_MESSAGES';
export const GET_MESSAGES_SUCCESS = 'GET_MESSAGES_SUCCESS';
export const GET_MESSAGES_FAIL = 'GET_MESSAGES_FAIL';

export const GET_ALL_MESSAGES = 'GET_ALL_MESSAGES';
export const GET_ALL_MESSAGES_SUCCESS = 'GET_ALL_MESSAGES_SUCCESS';
export const GET_ALL_MESSAGES_FAIL = 'GET_ALL_MESSAGES_FAIL';

export const GET_ADD_AGAIN_GIFT = 'GET_ADD_AGAIN_GIFT';
export const GET_ADD_AGAIN_GIFT_SUCCESS = 'GET_ADD_AGAIN_GIFT_SUCCESS';
export const GET_ADD_AGAIN_GIFT_FAIL = 'GET_ADD_AGAIN_GIFT_FAIL';

export const UPDATE_GIFT_ITEM_DETAILS = 'UPDATE_GIFT_ITEM_DETAILS';
export const UPDATE_GIFT_ITEM_DETAILS_SUCCESS =
  'UPDATE_GIFT_ITEM_DETAILS_SUCCESS';
export const UPDATE_GIFT_ITEM_DETAILS_FAIL = 'UPDATE_GIFT_ITEM_DETAILS_FAIL';

export const SEND_THANKYOU_MESSAGE_DETAILS = 'SEND_THANKYOU_MESSAGE_DETAILS';
export const SEND_THANKYOU_MESSAGE_DETAILS_SUCCESS =
  'SEND_THANKYOU_MESSAGE_DETAILS_SUCCESS';
export const SEND_THANKYOU_MESSAGE_DETAILS_FAIL =
  'SEND_THANKYOU_MESSAGE_DETAILS_FAIL';

export const TRACK_ORDER = 'TRACK_ORDER';
export const TRACK_ORDER_SUCCESS = 'TRACK_ORDER_SUCCESS';
export const TRACK_ORDER_FAIL = 'TRACK_ORDER_FAIL';

export const EVENT_SUMMARY_INFO = 'EVENT_SUMMARY_INFO';
export const EVENT_SUMMARY_INFO_SUCCESS = 'EVENT_SUMMARY_INFO_SUCCESS';
export const EVENT_SUMMARY_INFO_FAIL = 'EVENT_SUMMARY_INFO_FAIL';

export const SET_EVENT_SUMMARY_RESPONSE = 'SET_EVENT_SUMMARY_RESPONSE';

export const SET_NOTIFICATION_COUNT = 'SET_NOTIFICATION_COUNT';

export const UPDATE_FAVOURITE = 'UPDATE_FAVOURITE';
export const SET_MODE_OF_DELIVERY_ADDRESS = 'SET_MODE_OF_DELIVERY_ADDRESS';

export const GET_EVENT_DETAILS = 'GET_EVENT_DETAILS';
export const GET_EVENT_DETAILS_SUCCESS = 'GET_EVENT_DETAILS_SUCCESS';
export const GET_EVENT_DETAILS_FAIL = 'GET_EVENT_DETAILS_FAIL';

export const GET_EVENT_THRESHOLD_GIFT_DETAILS =
  'GET_EVENT_THRESHOLD_GIFT_DETAILS';
export const GET_EVENT_THRESHOLD_GIFT_DETAILS_SUCCESS =
  'GET_EVENT_THRESHOLD_GIFT_DETAILS_SUCCESS';
export const GET_EVENT_THRESHOLD_GIFT_DETAILS_FAIL =
  'GET_EVENT_THRESHOLD_GIFT_DETAILS_FAIL';

export const GET_PURCHASE_INFO_DETAILS = 'GET_PURCHASE_INFO_DETAILS';
export const GET_PURCHASE_INFO_DETAILS_SUCCESS =
  'GET_PURCHASE_INFO_DETAILS_SUCCESS';
export const GET_PURCHASE_INFO_DETAILS_FAIL = 'GET_PURCHASE_INFO_DETAILS_FAIL';

export const GET_GIFTLIST_MARKETING_CONTENT = 'GET_GIFTLIST_MARKETING_CONTENT';
export const GET_GIFTLIST_MARKETING_CONTENT_SUCCESS =
  'GET_GIFTLIST_MARKETING_CONTENT_SUCCESS';
export const GET_GIFTLIST_MARKETING_CONTENT_FAIL =
  'GET_GIFTLIST_MARKETING_CONTENT_FAIL';

export const GET_GIFTLIST_FOOTER_MARKETING_CONTENT =
  'GET_GIFTLIST_FOOTER_MARKETING_CONTENT';
export const GET_GIFTLIST_FOOTER_MARKETING_CONTENT_SUCCESS =
  'GET_GIFTLIST_FOOTER_MARKETING_CONTENT_SUCCESS';
export const GET_GIFTLIST_FOOTER_MARKETING_CONTENT_FAIL =
  'GET_GIFTLIST_FOOTER_MARKETING_CONTENT_FAIL';

export const TRANSFERENCE_STATEMENT_TAB = 'TRANSFERENCE_STATEMENT_TAB';

export const RESET_STORE = 'RESET_STORE';
export function resetStore() {
  return {
    type: RESET_STORE,
  };
}

export function getEventSummaryInfo(
  eventId,
  profileId,
  emailId,
  plasticCardNumber,
) {
  const _eventInfo = {};
  _eventInfo.brand = commonUtil.getBrand();
  _eventInfo.channel = commonUtil.getChannel();
  if (eventId) {
    _eventInfo.eventId = eventId;
  }
  if (profileId) {
    _eventInfo.profileId = profileId;
  }
  if (emailId) {
    _eventInfo.emailId = emailId;
  }
  if (plasticCardNumber) {
    _eventInfo.plasticCardNumber = plasticCardNumber;
  }
  // return commonUtil.triggerServerRequest({ url: '/api/getEventSummaryInfo', method: 'POST', data: _eventInfo });
  return {
    types: [
      EVENT_SUMMARY_INFO,
      EVENT_SUMMARY_INFO_SUCCESS,
      EVENT_SUMMARY_INFO_FAIL,
    ],
    promise: (client) =>
      client.post('/api/getEventSummaryInfo', {
        data: _eventInfo,
      }),
  };
}

export function getMessagesService(eventId, itemId) {
  const _getMessages = {};
  _getMessages.brand = commonUtil.getBrand();
  _getMessages.channel = commonUtil.getChannel();
  _getMessages.eventId = eventId;
  _getMessages.purchaseItemId = itemId;
  return {
    types: [GET_MESSAGES, GET_MESSAGES_SUCCESS, GET_MESSAGES_FAIL],
    promise: (client) =>
      client.post('/api/getMessages', {
        data: _getMessages,
      }),
  };
}

export function getAllMessagesService(eventId) {
  const _getAllMessages = {};
  _getAllMessages.brand = commonUtil.getBrand();
  _getAllMessages.channel = commonUtil.getChannel();
  _getAllMessages.eventId = eventId;
  return {
    types: [GET_ALL_MESSAGES, GET_ALL_MESSAGES_SUCCESS, GET_ALL_MESSAGES_FAIL],
    promise: (client) =>
      client.post('/api/getAllMessages', {
        data: _getAllMessages,
      }),
  };
}

export function addAgainGiftItem(eventId, skuId) {
  const _addAgainGiftItem = {};
  _addAgainGiftItem.brand = commonUtil.getBrand();
  _addAgainGiftItem.channel = commonUtil.getChannel();
  _addAgainGiftItem.eventId = eventId;
  _addAgainGiftItem.skuId = skuId;
  return commonUtil.triggerServerRequest({
    url: '/api/addAgainGiftItem',
    method: 'POST',
    data: _addAgainGiftItem,
  });
}

export function saveQuantity(eventId, giftItemId, skuId, quantity) {
  const _quantity = {};
  _quantity.brand = commonUtil.getBrand();
  _quantity.channel = commonUtil.getChannel();
  _quantity.eventId = eventId;
  _quantity.giftItemId = giftItemId;
  _quantity.skuId = skuId;
  _quantity.quantity = quantity;
  return commonUtil.triggerServerRequest({
    url: '/api/saveQuantity',
    method: 'POST',
    data: _quantity,
  });
}

export function sendMailToGuest(guestId) {
  const _emailGiftlist = {};
  _emailGiftlist.guestId = guestId;
  return commonUtil.triggerServerRequest({
    url: '/api/sendMailToGuest',
    method: 'POST',
    data: _emailGiftlist,
  });
}

//

export function setFavouriteGift(eventId, giftItemId, skuId, isFavourite) {
  const _favouriteInput = {};
  _favouriteInput.brand = commonUtil.getBrand();
  _favouriteInput.channel = commonUtil.getChannel();
  _favouriteInput.eventId = eventId;
  _favouriteInput.giftItemId = giftItemId;
  _favouriteInput.skuId = skuId;
  _favouriteInput.isFavourite = isFavourite;

  return commonUtil.triggerServerRequest({
    url: '/api/setFavouriteGift',
    method: 'POST',
    data: _favouriteInput,
  });
}
// Correct Registered

export function getRegisteredGiftList(
  eventId,
  sorting,
  searchKeyword,
  priceOrderCategory,
  currentPage,
  isShowAll,
  categoryFilter,
  getAllItems
) {
  const _registeredGifts = {};
  _registeredGifts.brand = commonUtil.getBrand();
  _registeredGifts.channel = commonUtil.getChannel();
  _registeredGifts.eventId = eventId;
  _registeredGifts.priceOrder = sorting;
  _registeredGifts.searchKeyword = searchKeyword;
  _registeredGifts.priceOrderCategory = priceOrderCategory;
  _registeredGifts.isShowAll = getAllItems ? true : isShowAll || false;
  if (currentPage) {
    _registeredGifts.currentPage = currentPage;
  }

  if (categoryFilter && categoryFilter.length > 0) {
    _registeredGifts.categoryFilter = categoryFilter;
  }
  _registeredGifts.resultsPerPage =
    commonUtil.getChannel().toLocaleLowerCase() === 'web' ? 50 : 30;

  let types =  [
    GET_REGISTERED_GIFT_LIST,
    GET_REGISTERED_GIFT_LIST_SUCCESS,
    GET_REGISTERED_GIFT_LIST_FAIL,
  ]

  if(getAllItems) {
    types =  [
      GET_ALL_REGISTERED_GIFT_LIST,
      GET_ALL_REGISTERED_GIFT_LIST_SUCCESS,
      GET_ALL_REGISTERED_GIFT_LIST_FAIL,
    ]
  }

  return {
    types: types,
    promise: (client) =>
      client.post('/api/getRegalosRegistrados', {
        data: _registeredGifts,
      }),
  };
}

export function updateFavouriteToRegisteredGiftList(giftItemId, status) {
  return {
    type: UPDATE_FAVOURITE,
    data: { giftItemId, status },
  };
}

export function handleRemoveItemsFromGiftlist(eventId, giftItemIds) {
  const _removeItems = {};
  _removeItems.brand = commonUtil.getBrand();
  _removeItems.channel = commonUtil.getChannel();
  _removeItems.eventId = eventId;
  _removeItems.giftItemIds = giftItemIds;
  return commonUtil.triggerServerRequest({
    url: '/api/removeItemsFromGiftlist',
    method: 'POST',
    data: _removeItems,
  });
}

export function removeItemsFromGiftlist(registeredItem) {
  return {
    type: REMOVE_GIFT,
    data: registeredItem,
  };
}
export function handleChangeDeliveryAddress(eventId, giftItemIds, addressId) {
  const _deliveryAddress = {};
  _deliveryAddress.brand = commonUtil.getBrand();
  _deliveryAddress.channel = commonUtil.getChannel();
  _deliveryAddress.eventId = eventId;
  _deliveryAddress.giftItemIds = giftItemIds;
  _deliveryAddress.addressId = addressId;
  return commonUtil.triggerServerRequest({
    url: '/api/changeDeliveryAddress',
    method: 'POST',
    data: _deliveryAddress,
  });
}
export function changeDeliveryAddress(registeredItem) {
  return {
    type: SET_DELIVERY_ADDRESS_SUCCESS,
    data: registeredItem,
  };
}

export function handleChangeDeliveryMode(
  eventId,
  giftItemIds,
  priceOrder,
  filteringParameters,
  modeOfDelivery,
) {
  const _deliveryMode = {};
  _deliveryMode.brand = commonUtil.getBrand();
  _deliveryMode.channel = commonUtil.getChannel();
  _deliveryMode.eventId = eventId;
  _deliveryMode.giftItemIds = giftItemIds;
  _deliveryMode.priceOrder = priceOrder;
  _deliveryMode.modeOfDelivery = modeOfDelivery;
  _deliveryMode.filteringParameters = filteringParameters;
  return commonUtil.triggerServerRequest({
    url: '/api/changeDeliveryMode',
    method: 'POST',
    data: _deliveryMode,
  });
}

export function changeDeliveryMode(registeredItem) {
  return {
    type: SET_MODE_OF_DELIVERY_SUCCESS,
    data: registeredItem,
  };
}

// Received List

export function getReceivedGiftList(
  eventId,
  searchKeyword,
  priceOrder,
  filteringParameterss,
  currentPage,
) {
  const _receivedgift = {};
  _receivedgift.brand = commonUtil.getBrand();
  _receivedgift.channel = commonUtil.getChannel();
  _receivedgift.eventId = eventId;
  if (filteringParameterss) {
    _receivedgift.filteringParameters = filteringParameterss;
  }
  _receivedgift.isShowAll = false;
  if (priceOrder) {
    _receivedgift.priceOrder = priceOrder;
  }
  _receivedgift.searchKeyword = searchKeyword;
  if (currentPage) {
    _receivedgift.currentPage = currentPage;
  }
  _receivedgift.resultsPerPage =
    commonUtil.getChannel().toLocaleLowerCase() === 'web' ? 50 : 30;

  return {
    types: [
      GET_RECEIVED_GIFT_LIST,
      GET_RECEIVED_GIFT_LIST_SUCCESS,
      GET_RECEIVED_GIFT_LIST_FAIL,
    ],
    promise: (client) =>
      client.post('/api/getRegaloRecibidos', {
        data: _receivedgift,
      }),
  };
}

// Personal Shopping Gift List:
export function isPersonalShoppingListLoaded(globalState) {
  return (
    globalState.giftList.personalShoppingList &&
    globalState.giftList.personalShoppingList.loaded
  );
}

export function getPersonalShoppingList(
  eventId,
  searchKeyword,
  priceOrder,
  filteringParameterss,
  currentPage,
) {
  const _personalShopping = {};
  _personalShopping.brand = commonUtil.getBrand();
  _personalShopping.channel = commonUtil.getChannel();
  _personalShopping.eventId = eventId;
  if (filteringParameterss) {
    _personalShopping.filteringParameters = filteringParameterss;
  }
  _personalShopping.isShowAll = false;

  if (priceOrder) {
    _personalShopping.priceOrder = priceOrder;
  }
  _personalShopping.searchKeyword = searchKeyword;
  if (currentPage) {
    _personalShopping.currentPage = currentPage;
  }
  _personalShopping.resultsPerPage =
    commonUtil.getChannel().toLocaleLowerCase() === 'web' ? 50 : 30;

  return {
    types: [
      GET_PERSONAL_SHOPPING_LIST,
      GET_PERSONAL_SHOPPING_LIST_SUCCESS,
      GET_PERSONAL_SHOPPING_LIST_FAIL,
    ],
    // promise: client => client.get('/api/registeredGiftList'), // params not used, just shown as demonstration
    promise: (client) =>
      client.post('/api/getComprasPersonales', {
        data: _personalShopping,
      }),
  };
}

// Registered Gift's Update for WAP

export function updateGiftItemDetails(
  eventId,
  giftItemId,
  quantity,
  addressId,
  modeOfDelivery,
  isFavourite,
) {
  const _updateGiftItemDetails = {};
  _updateGiftItemDetails.brand = commonUtil.getBrand();
  _updateGiftItemDetails.channel = commonUtil.getChannel();
  _updateGiftItemDetails.eventId = eventId;
  _updateGiftItemDetails.giftItemId = giftItemId;
  _updateGiftItemDetails.quantity = quantity;
  if (modeOfDelivery != 'electronic') {
    _updateGiftItemDetails.addressId = addressId;
  }
  _updateGiftItemDetails.modeOfDelivery = modeOfDelivery;
  _updateGiftItemDetails.isFavourite = isFavourite;
  return commonUtil.triggerServerRequest({
    url: '/api/updateGiftItemDetails',
    method: 'POST',
    data: _updateGiftItemDetails,
  });
}

// Add thank you message

export function addThankYouMessage(eventId, itemId, message, guestEmail) {
  const _addThankYouMessageDetails = {};
  _addThankYouMessageDetails.brand = commonUtil.getBrand();
  _addThankYouMessageDetails.channel = commonUtil.getChannel();
  _addThankYouMessageDetails.eventId = eventId;
  _addThankYouMessageDetails.itemId = itemId;
  _addThankYouMessageDetails.message = message;
  if (guestEmail) {
    _addThankYouMessageDetails.guestEmail = guestEmail;
  }

  return commonUtil.triggerServerRequest({
    url: '/api/addThankYouMessage',
    method: 'POST',
    data: _addThankYouMessageDetails,
  });
}

export function getTrackOrder(eventId, itemId, pedidoNo) {
  const _trackOrder = {};
  _trackOrder.brand = commonUtil.getBrand();
  _trackOrder.channel = commonUtil.getChannel();
  _trackOrder.eventId = eventId;
  _trackOrder.pedidoNo = pedidoNo;
  _trackOrder.itemId = itemId;
  return {
    types: [TRACK_ORDER, TRACK_ORDER_SUCCESS, TRACK_ORDER_FAIL],
    promise: (client) =>
      client.post('/api/getTrackOrder', {
        data: _trackOrder,
      }),
  };
}
export function setEventSummaryResponse(eventSummary) {
  return {
    type: SET_EVENT_SUMMARY_RESPONSE,
    data: eventSummary,
  };
}
export const setNotificationCount = (notificationValue) => ({
  type: SET_NOTIFICATION_COUNT,
  data: notificationValue,
});

export function getEventDetails(eventId, profileId) {
  const payload = {};
  payload.brand = commonUtil.getBrand().toUpperCase();
  payload.channel = commonUtil.getChannel().toUpperCase();
  payload.eventId = eventId;
  payload.profileId = profileId;
  return {
    types: [
      GET_EVENT_DETAILS,
      GET_EVENT_DETAILS_SUCCESS,
      GET_EVENT_DETAILS_FAIL,
    ],
    promise: (client) =>
      client.post('/api/EditEvent/eventDetails', {
        data: payload,
      }), // params not used, just shown as demonstration
  };
}

export function saveEventThresholdGiftDetails(requestBody) {
  const payload = {};
  payload.brand = commonUtil.getBrand().toUpperCase();
  payload.channel = commonUtil.getChannel().toUpperCase();
  payload.eventId = requestBody.eventId;
  payload.addressId = requestBody.addressId;
  payload.eventType = requestBody.eventType;
  payload.storeSelected = requestBody.storeSelected;

  return commonUtil.triggerServerRequest({
    url: '/api/EditEvent/EventThresholdGift',
    method: 'POST',
    data: payload,
  });
}

export function getEventThresholdGiftDetails(eventId) {
  const payload = {};
  payload.brand = commonUtil.getBrand().toUpperCase();
  payload.channel = commonUtil.getChannel().toUpperCase();
  payload.eventId = eventId;
  return {
    types: [
      GET_EVENT_THRESHOLD_GIFT_DETAILS,
      GET_EVENT_THRESHOLD_GIFT_DETAILS_SUCCESS,
      GET_EVENT_THRESHOLD_GIFT_DETAILS_FAIL,
    ],
    promise: (client) =>
      client.post('/api/EditEvent/GetEventThresholdGift', {
        data: payload,
      }),
  };
}

export function getPurchaseInfoDetails(eventId) {
  const payload = {};
  payload.brand = commonUtil.getBrand().toUpperCase();
  payload.channel = commonUtil.getChannel().toUpperCase();
  payload.eventId = eventId;
  return {
    types: [
      GET_PURCHASE_INFO_DETAILS,
      GET_PURCHASE_INFO_DETAILS_SUCCESS,
      GET_PURCHASE_INFO_DETAILS_FAIL,
    ],
    promise: (client) =>
      client.post('/api/EditEvent/GetPurchaseAmount', {
        data: payload,
      }),
  };
}

export function getGiftlistMarketingContent(page_id) {
  const payload = {};
  payload.brand = commonUtil.getBrand().toUpperCase();
  payload.channel = commonUtil.getChannel().toUpperCase();
  payload.page_id = page_id;
  return {
    types: [
      GET_GIFTLIST_MARKETING_CONTENT,
      GET_GIFTLIST_MARKETING_CONTENT_SUCCESS,
      GET_GIFTLIST_MARKETING_CONTENT_FAIL,
    ],
    promise: (client) =>
      client.get(
        '/api/getMarketingLandingPage?' +
          commonUtil.objectToQueryParams(payload),
      ),
  };
}

export function getGiftlistFooterMarketingContent(page_id) {
  const payload = {};
  payload.brand = commonUtil.getBrand().toUpperCase();
  payload.channel = commonUtil.getChannel().toUpperCase();
  payload.page_id = page_id;
  return {
    types: [
      GET_GIFTLIST_FOOTER_MARKETING_CONTENT,
      GET_GIFTLIST_FOOTER_MARKETING_CONTENT_SUCCESS,
      GET_GIFTLIST_FOOTER_MARKETING_CONTENT_FAIL,
    ],
    promise: (client) =>
      client.get(
        '/api/getMarketingLandingPage?' +
          commonUtil.objectToQueryParams(payload),
      ),
  };
}

export const setGiftListTransferenceStatementTab =
  (type) => (dispatch, getState) => {
    dispatch({
      type: TRANSFERENCE_STATEMENT_TAB,
      data: type,
    });
  };
